import React from 'react';
import {func, any} from 'prop-types';
import catchUnsavedChanges from 'hoc/catchUnsavedChanges';
import {isFunction} from "../../../utils/DBUtils";
import ContentEditable from "./ContentEditable";

// Originally implemented to be stateless,
// but since the value needs to be kept track of to change according to other values (linked values, color picker)
// now keeping track of state. This is duplicate logic of AutoSaveField so might be better to pull up into that
class OnBlurContentEditable extends React.PureComponent {
    static propTypes = {
        // provided by catchUnsavedChanges HOC
        isEditing: func.isRequired,
        doneEditing: func.isRequired,

        value: any,
        onChange: func
    };

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.value !== nextProps.value) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    onBlur = (event, data) => {
        if (isFunction(this.props.onChange)) {
            this.props.onChange(event, {});
            this.props.doneEditing();
        }
    };

    setValue = (event) => {
        this.props.isEditing();
        this.setState({
            value: event.target.value
        });
    };

    render() {
        // Raises onChange on focus and blur to get the value change when the markup buttons are pressed
        // Logic in AutoSaveField that prevents save value from being saved and the global debounce on saves should prevent unnecessary save calls
        return <ContentEditable {...this.props}
                                html={this.state.value}
                                onChange={this.setValue}
                                onFocus={this.onBlur}
                                onBlur={this.onBlur}/>;
    }
}

export default catchUnsavedChanges(OnBlurContentEditable);



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/OnBlurContentEditable.jsx